module.exports = __webpack_public_path__ + "static/HUB1-3555de7410472737a65d35b6b28daa46.jpg";